import { api } from 'utility';
import { getCreditUrl, getGuildServiceUrl } from 'URLs';
export function getCreditAccounts(obj) {
  const params = { ...obj };
  return api.get(getCreditUrl(), { params }).then((res) => res.data);
}
export function getGuilds() {
  return api.get(getGuildServiceUrl()).then((res) => res.data);
}

export default { getCreditAccounts, getGuilds };
